import React, { Component, Fragment } from "react";
import DispatchProps from "../../../utils/DispatchProps";
import Actions from "../../../redux/Actions";
import OnboardHelpBox from "./OnboardHelpBox";
import OnboardTimeline, {OnboardTimelineItem} from "./OnboardTimeline";
import OnboardNavigation from "./OnboardNavigation";
import { IRootState } from "../../../store";
import { connect } from "react-redux";
import { History } from "history";
import {
    SchoolWorkloadConfig, sortYearGroupingsByIsAfterValues, YearGrouping,
} from "../../../models/SchoolWorkloadConfig";
import ApiService from "../../ApiService";
import * as _ from "lodash";
import SdsYear from "../../../models/SdsYear";
import {MessageBarType} from "office-ui-fabric-react";
import AssignYearsEditor from "../../AssignYearsEditor";
import PageTitle from "../../PageTitle";
import School from "../../../models/School";

interface OnboardYearGroupingYearsPageProps {
    tenantId: string;
    schoolCode: string;

    apiService: ApiService;
    history: History;
}

interface OnboardYearGroupingYearsPageState {
    schoolWorkloadConfig?: SchoolWorkloadConfig;
    yearGroupingItems: YearGrouping[];
    sdsYears: SdsYear[];
}

class OnboardYearGroupingYearsPage extends Component<OnboardYearGroupingYearsPageProps & DispatchProps, OnboardYearGroupingYearsPageState> {

    constructor(props: OnboardYearGroupingYearsPageProps & DispatchProps) {
        super(props);
        this.state = {
            schoolWorkloadConfig: undefined,
            yearGroupingItems: [],
            sdsYears: [],
        };
    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId)
        {
            const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);
            const sdsYears = await this.props.apiService.getSdsYearsForSchool(this.props.tenantId,this.props.schoolCode);
            this.setState({
                schoolWorkloadConfig,
                sdsYears,
                yearGroupingItems: sortYearGroupingsByIsAfterValues(schoolWorkloadConfig.yearGroupings.items!)
            });
        }
    }

    async componentDidUpdate(prevProps: Readonly<OnboardYearGroupingYearsPageProps & DispatchProps>, prevState: OnboardYearGroupingYearsPageState): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode)
        {
            const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);
            const sdsYears = await this.props.apiService.getSdsYearsForSchool(this.props.tenantId, this.props.schoolCode);
            this.setState({
                schoolWorkloadConfig,
                sdsYears,
            });

        }

        if(this.state.schoolWorkloadConfig !== prevState.schoolWorkloadConfig) {
            this.setState({
                yearGroupingItems: sortYearGroupingsByIsAfterValues(this.state.schoolWorkloadConfig?.yearGroupings?.items!)
            });
        }
       
    }

    private save = async (): Promise<boolean> => {
        if(this.state.schoolWorkloadConfig === undefined) {
            console.log("Cannot find workload config"); 
            return false;
        }

        const updatedConfig = _.cloneDeep(this.state.schoolWorkloadConfig);
        
        updatedConfig.yearGroupings.items = this.state.yearGroupingItems;

        try {
            const savedSchoolWorkloadConfig = await this.props.apiService.putSchoolConfigJson(this.props.tenantId, this.props.schoolCode, updatedConfig);
            this.setState({
                schoolWorkloadConfig: savedSchoolWorkloadConfig
            });

            await this.props.dispatch(Actions.showMessageBar("Saved year grouping years to config", MessageBarType.success));
        }
        catch (e) {
            await this.props.dispatch(Actions.showMessageBar(`Unable to save year grouping years: ${e}`, MessageBarType.error));
        }

        return true;
    }

    public render(): JSX.Element {
        
       
        return (
            <Fragment>
                <PageTitle title={`Assign Years`} />
                <OnboardHelpBox currentTimelineItemKey={"year-grouping-years"}/>
                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                <div className="flex-column flex--align-items-center">
                                    <AssignYearsEditor tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}
                                                       sdsYears={this.state.sdsYears}
                                                       yearGroupingItems={this.state.yearGroupingItems}
                                                       onYearGroupingChange={(yearGroups: YearGrouping[]) => this.setState({yearGroupingItems: yearGroups})}/>
                                </div>
                                <OnboardNavigation currentTimelineItemKey={"year-grouping-years"} timelineItems={timelineItems}
                                                   completeItem={this.save} enableNext={true} enableSave={true}
                                                   history={this.props.history} tenantId={this.props.tenantId}
                                                   schoolCode={this.props.schoolCode}/>
                            </Fragment>
                        );
                    }}
                </OnboardTimeline>

            </Fragment>
        )
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardYearGroupingYearsPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(OnboardYearGroupingYearsPage)